import {Box} from '@mui/material';
import {Outlet} from 'react-router-dom';

export default function PropertyLayout() {
  return (
    <Box>
      <Outlet />
    </Box>
  );
}
